<template>
  <div
    class="banner-page inner-page contact-page"
    :style="`background-image: url('${getImageUrl(
      contact.image
    )}'); background-size: cover; background-repeat: no-repeat; background-position: center center;`"
  >
    <div class="content">
      <div class="banner-text" :lang="langStore.lang === 'gr' ? 'el' : 'en'">{{ $t("contact_us") }}</div>
      <p class="t1">
        {{ contact.description }}
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { langStore } from "../../langStore";

export default {
  name: "BannerPageComponent",
  props: {
    msg: String,
  },
  data() {
    return {
      langStore,
      contact: {},
    };
  },

  watch: {
    "langStore.lang"() {
      this.fetchContact();
    },
  },

  mounted() {
    this.fetchContact();
  },

  methods: {
    async fetchContact() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/api/contact`,
          { params: { lang: this.langStore.lang } }
        );

        this.contact = response.data;

        // WAIT FOR IMAGES TO LOAD
        this.waitForImages();
      } catch (error) {
        console.error("There was an error fetching the data:", error);
        this.$emitContentReady(); // still hide preload
      }
    },

    getImageUrl(photo) {
      return `${process.env.VUE_APP_BASE_URL}/uploads/website/` + photo;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
